export const RANK_STYLES = {
  "Alpha": { bg: "bg-amber-500/10", text: "text-amber-400", border: "border-amber-500/40", ring: "ring-amber-500/40", glow: "shadow-[0_0_16px_rgba(245,158,11,0.35)]", icon: "crown" },
  "Beta": { bg: "bg-sky-500/10", text: "text-sky-400", border: "border-sky-500/40", ring: "ring-sky-500/40", glow: "shadow-[0_0_16px_rgba(56,189,248,0.3)]", icon: "shield" },
  "Delta": { bg: "bg-emerald-500/10", text: "text-emerald-400", border: "border-emerald-500/40", ring: "ring-emerald-500/40", glow: "", icon: "eye" },
  "Omega": { bg: "bg-slate-500/10", text: "text-slate-300", border: "border-slate-500/40", ring: "ring-slate-500/40", glow: "", icon: "moon" },
};

// color-key -> tailwind style (used for admin-created custom ranks)
export const RANK_COLORS = {
  amber: { bg: "bg-amber-500/10", text: "text-amber-400", border: "border-amber-500/40", ring: "ring-amber-500/40", glow: "shadow-[0_0_16px_rgba(245,158,11,0.35)]", icon: "crown" },
  sky: { bg: "bg-sky-500/10", text: "text-sky-400", border: "border-sky-500/40", ring: "ring-sky-500/40", glow: "shadow-[0_0_16px_rgba(56,189,248,0.3)]", icon: "shield" },
  emerald: { bg: "bg-emerald-500/10", text: "text-emerald-400", border: "border-emerald-500/40", ring: "ring-emerald-500/40", glow: "", icon: "eye" },
  slate: { bg: "bg-slate-500/10", text: "text-slate-300", border: "border-slate-500/40", ring: "ring-slate-500/40", glow: "", icon: "moon" },
  purple: { bg: "bg-purple-500/10", text: "text-purple-400", border: "border-purple-500/40", ring: "ring-purple-500/40", glow: "", icon: "wolf" },
  rose: { bg: "bg-rose-500/10", text: "text-rose-400", border: "border-rose-500/40", ring: "ring-rose-500/40", glow: "", icon: "heart" },
  cyan: { bg: "bg-cyan-500/10", text: "text-cyan-300", border: "border-cyan-500/40", ring: "ring-cyan-500/40", glow: "", icon: "shield" },
};

export const COLOR_OPTIONS = Object.keys(RANK_COLORS);

// dynamic catalog registry (name -> color key), populated from /api/ranks
let dynamicRankColors = {};
export function setRankCatalog(list) {
  dynamicRankColors = {};
  (list || []).forEach((r) => { dynamicRankColors[r.name] = r.color; });
}

export const RANKS = ["Alpha", "Beta", "Delta", "Omega"];

export function rankStyle(rank) {
  const colorKey = dynamicRankColors[rank];
  if (colorKey && RANK_COLORS[colorKey]) return RANK_COLORS[colorKey];
  return RANK_STYLES[rank] || RANK_COLORS.slate;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  if (s < 604800) return `${Math.floor(s / 86400)}d`;
  return d.toLocaleDateString();
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export const STATUSES = ["Howling", "Hunting", "Resting in Den"];
export const STATUS_COLOR = {
  "Howling": "text-sky-400",
  "Hunting": "text-amber-400",
  "Resting in Den": "text-slate-500",
};
